export default function removeCharSpecial(text) {
  var newText = String(text)
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "");

  return newText;
}
